// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Lu8Gz","header":"ReportDetails_header__131T6","title":"ReportDetails_title__1TyrZ","left":"ReportDetails_left__Ubs_K"};